/* eslint-disable no-underscore-dangle */
import {
  Card,
  CardContent,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useUpdateEffect } from 'react-use';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box } from '@mui/system';
import ScheduleItem from './ScheduleItem';

const CalendarStatusCardByGroup = ({
  className,
  name,
  id,
  date,
  list,
  checkedData,
  handleUpdateClick,
  handleDeleteClick,
  handleChangeCheck,
  bManagerMode,
}) => {
  const [btnEnabled, setEnabled] = useState(false);
  const onChangeCheck = (e) => {
    const { checked } = e.target;
    setEnabled(checked);
    handleChangeCheck(e);
  };

  useUpdateEffect(() => {
    const keys = Object.keys(checkedData);
    if (keys.length === 0) {
      setEnabled(false);
    } else {
      const result = list.find(({ _id: item }) => keys.indexOf(item) > -1);
      if (result) {
        setEnabled(true);
      }
    }
  }, [checkedData]);

  return (
    <Card variant="outlined" sx={{ position: 'relative' }}>
      <Box
        sx={{ height: '100%', width: '3px', position: 'absolute' }}
        className={className}
      />
      <Box
        display="inline-flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ pl: 1.5, pr: 1, py: 0.5, width: '100%' }}
      >
        <Typography variant="h6">{name}</Typography>
        <Stack direction="row">
          <IconButton
            color="secondary"
            onClick={handleUpdateClick}
            disabled={!btnEnabled}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            color="secondary"
            onClick={handleDeleteClick}
            disabled={!btnEnabled}
          >
            <DeleteOutlineIcon />
          </IconButton>
        </Stack>
      </Box>
      <Divider />
      <CardContent>
        <Stack gap={1}>
          {list &&
            list.map((v) => (
              <ScheduleItem
                {...{
                  data: v,
                  id,
                  onChangeCheck,
                  checkedData,
                  bManagerMode,
                }}
                key={`${date}_${v._id}`}
              />
            ))}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default CalendarStatusCardByGroup;
